import NiceModal from '@ebay/nice-modal-react';
import { useContext, useEffect, useRef } from 'react';

import { onSessionEnd } from '@/utils/session';

// DEV-3867: NiceModal.Provider is mounted outside the routes, so its windows survive the
// switch to the sign-in screen and cover it. Remove every open one when the session ends.
export const CloseModalsOnSessionEnd = () => {
  const modals = useContext(NiceModal.NiceModalContext);
  const modalsRef = useRef(modals);
  modalsRef.current = modals;

  useEffect(
    () =>
      onSessionEnd(() => {
        Object.keys(modalsRef.current).forEach((id) => NiceModal.remove(id));
      }),
    []
  );

  return null;
};
